$(window).on('load', function () {
    $('.preloader img').fadeOut();
    $('.preloader').fadeOut();
    $('.wrapper').fadeIn();
    $('#username').focus();
});